<div class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <div class="header-side"></div>
  <div class="dialog-title-text" cdkDragHandle>
      {{ dialogTitle() }}
  </div>
  <button mat-icon-button class="close-btn" (click)="onClose()">
    <mat-icon>close</mat-icon>
  </button>
</div>
  
<mat-dialog-content>
  <form [formGroup]="drForm" class="form-grid">
    <div class="form-grid-row">
      <mat-form-field appearance="outline">
          <mat-label>Enter a date range</mat-label>
          <mat-date-range-input id="dtRange" data-testid="dtRange" [formGroup]="range" [rangePicker]="picker" [min]="minDate">
              <input matStartDate id="startDateInput" placeholder="Start date" formControlName="start" (blur)="dateformat($event)" (keydown)="onKeydown($event)">
              <input matEndDate id="endDateInput" placeholder="End date" formControlName="end" (blur)="dateformat($event)" (keydown)="onKeydown($event)">
          </mat-date-range-input>
          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>
    </div>
    <div class="form-grid-row">
      <mat-form-field appearance="outline">
        <mat-label>Manure</mat-label>
        <input matInput formControlName="manure" name="manure" placeholder="Enter Manure"
          (input)="roundOff($event, 999999, 1, 'manure')">
      </mat-form-field>
    </div> 
      @for (item of controlNames; track getUniqueKey(item); let i = $index) { 
        <div class="form-grid-row">         
          <mat-form-field appearance="outline">
            @if(item.colorCode !== ''){
              <mat-label><span class="rounded-label" [style.backgroundColor]="item.colorCode">{{ item.tankName }}</span></mat-label>
            }@else {
              <mat-label>{{ item.tankName }}</mat-label>
            }
            <input matInput type="text" [formControlName]="getControlName(item)" placeholder="Enter {{ item.tankName }}"
              (input)="roundOff($event, 999999, 1, getControlName(item))">
          </mat-form-field>
        </div>  
      }      
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end" class="dialog-footer">
  <button data-testid="btnClose" mat-raised-button color="primary" mat-primary type="button" (click)="onClose()">
    Cancel
  </button>
  @if(canSave){
    <button data-testid="btnSave" mat-raised-button color="primary" mat-primary type="submit" (click)="saveDRData()">
      Save
    </button>
  }
</mat-dialog-actions>
  